<template>
  <div
    class="flex items-center gap-4 group cursor-pointer"
    @click="navigateHome"
  >
    <img
      :src="logoSrc"
      alt="Logo"
      class="h-8 w-auto transform group-hover:scale-105 transition-transform duration-300 ease-out"
    />
    <img
      :src="logotitleSrc"
      alt="PhotoScope"
      class="h-6 w-auto ml-1 transform group-hover:scale-105 transition-transform duration-300 ease-out"
    />
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted, onUnmounted, computed } from "vue";

const router = useRouter();
// Logo 点击的实际导航目标是 AppLogo 内部决定的（/:lang/home，route name = 'Landing'），
// 埋点由各使用方按自身事件域自行上报，故这里只向外抛事件、不直接引用任何 analytics hook，
// 避免共享组件反向依赖 Navigation / Landing / Auth 三个域。
const emit = defineEmits(['logo-click']);
const isDarkMode = ref(false);

const logoSrc = computed(() =>
  isDarkMode.value
    ? require("@/assets/logo_white.svg")
    : require("@/assets/logo.svg")
);

const logotitleSrc = computed(() =>
  isDarkMode.value
    ? require("@/assets/logotitle_white.svg")
    : require("@/assets/logotitle.svg")
);

const detectDarkMode = () => {
  if (typeof document === "undefined") return false;
  const html = document.documentElement;
  return (
    html?.getAttribute("data-theme") === "dark" ||
    html?.classList.contains("dark") ||
    document.body?.classList.contains("dark")
  );
};

const syncDarkMode = () => {
  isDarkMode.value = detectDarkMode();
};

const observeThemeChanges = () => {
  syncDarkMode();

  // 观察 data-theme 属性变化
  const observer = new MutationObserver(() => {
    syncDarkMode();
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme", "class"],
  });

  return observer;
};

let themeObserver = null;

onMounted(() => {
  themeObserver = observeThemeChanges();
});

onUnmounted(() => {
  themeObserver?.disconnect();
});

const navigateHome = () => {
  // 先抛事件再导航：确保埋点在 router.push 引发组件卸载前发出。
  emit("logo-click");
  const currentLang = router.currentRoute.value.params.lang;
  router.push(`/${currentLang}/home`);
};
</script>
